import { render, staticRenderFns } from "./HwGroupsList.vue?vue&type=template&id=25af1a16&"
import script from "./HwGroupsList.vue?vue&type=script&lang=js&"
export * from "./HwGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports